import { RoleEnum } from '@zeus/index'

type Viewer = { role?: string | null, id?: string | null }
type Target = { id: string, roleName?: string | null }

/**
 * Qui peut consulter l'espace de qui : l'admin, sur un compte de son org qui n'est ni
 * le sien ni celui d'un autre admin. Même règle que `impersonateUser` côté API ; la
 * liste des utilisateurs et la fiche apprenant (#242) la lisent ici. Comptes comparés
 * par id : un apprenant en pseudo (#271) n'a pas d'e-mail.
 */
export function canImpersonate(viewer: Viewer, target: Target): boolean {
  return viewer.role === RoleEnum.Admin && viewer.id !== target.id && target.roleName !== RoleEnum.Admin
}
